import React from "react";

interface Props {
  onClick: () => void;
  children: React.ReactNode;
  ariaLabel?: string;
  title?: string;
  disabled?: boolean;
  /** When true, render with primary color emphasis (used for Reset / Recommended). */
  emphasis?: boolean;
}

/**
 * Shared inline action link/button for the Chat Designer (Branding / Layout / Effects).
 *
 * All inline actions — "Reset section", "Recommended", "▶ Preview" simulate buttons,
 * etc. — should use this component so styling, focus rings, and minimum hit-target
 * sizing stay consistent across the designer.
 */
export default function DesignerActionLink({
  onClick,
  children,
  ariaLabel,
  title,
  disabled,
  emphasis = true
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
      className="inline-flex items-center gap-1 text-xs hover:underline rounded-sm min-h-[24px] px-1 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--color-primary)]"
      style={emphasis ? { color: "var(--color-primary)" } : { color: "rgb(71 85 105)" }}
    >
      {children}
    </button>
  );
}
